<template>
  <div id="app">
    <!-- 全局Header -->
    <Header 
      @open-login-modal="openLoginModal"
      @open-register-modal="showRegisterModal = true"
    />
    
    <!-- 页面内容区域 -->
    <main class="lg:pt-20 pb-16 lg:pb-0">
      <router-view
        @open-login-modal="openLoginModal"
        @open-register-modal="showRegisterModal = true"
        @open-talent-modal="openTalentModal"
      />
    </main>
    
    <!-- 全局Footer - 仅在桌面端显示(1024px及以上) -->
    <Footer class="hidden lg:block" />
    
    <!-- 登录弹窗 -->
    <LoginModal 
      :visible="showLoginModal" 
      @close="closeLoginModal"
      @switch-to-register="switchToRegister"
    />
    
    <!-- 注册弹窗 -->
    <RegisterModal 
      :visible="showRegisterModal" 
      @close="showRegisterModal = false"
      @switch-to-login="switchToLogin"
    />
    
    <!-- 人才入库弹窗 -->
    <TalentModal 
      :visible="showTalentModal" 
      @close="showTalentModal = false"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import LoginModal from './components/LoginModal.vue'
import RegisterModal from './components/RegisterModal.vue'
import TalentModal from './components/TalentModal.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    LoginModal,
    RegisterModal,
    TalentModal
  },
  data() {
    return {
      showRegisterModal: false,
      showTalentModal: false
    }
  },
  computed: {
    ...mapState(['showLoginModal'])
  },
  methods: {
    switchToRegister() {
      this.$store.commit('HIDE_LOGIN_MODAL')
      this.showRegisterModal = true
    },
    switchToLogin() {
      this.showRegisterModal = false
      this.$store.commit('SHOW_LOGIN_MODAL')
    },
    openLoginModal() {
      this.$store.commit('SHOW_LOGIN_MODAL')
    },
    closeLoginModal() {
      this.$store.commit('HIDE_LOGIN_MODAL')
    },
    openTalentModal() {
      // 先验证用户是否登录
      if (!this.$store.getters.isLoggedIn) {
        this.$message.warning('请先登录后再申请入库')
        this.openLoginModal()
        return
      }
      // 已登录，打开人才入库弹框
      this.showTalentModal = true
    }
  }
}
</script>

<style>
/* 全局样式重置 - 使用Tailwind CSS的base样式 */
html, body {
  height: 100%;
  font-family: 'Inter', system-ui, sans-serif;
}

#app {
  min-height: 100vh;
}

/* 加载动画 */
.loader {
  border-top-color: #165DFF;
  animation: spinner 0.6s linear infinite;
}

@keyframes spinner {
  to { 
    transform: rotate(360deg); 
  }
}

/* 自定义动画 */
@keyframes fadeIn {
  from { 
    opacity: 0; 
    transform: translateY(10px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.animate-fade-in {
  animation: fadeIn 0.5s ease forwards;
}
</style>
